import $ from "jquery"
window.$ = $
window.jQuery = $

import "materialize-css/dist/js/materialize.min"

import "./contact"
import "./forms/userLoginForm"
import "./forms/userRegisterForm"
import "./forms/user2FAForm"
import "./forms/userResetPasswordStep1"
import "./forms/userResetPasswordStep2"
import "./forms/attendeeDeclinedReasonForm"
import Cookies from "js-cookie"

import {IsPageWithLocale} from "./lib/urlutils";

$(document).ready(function() {
    materializeInit();
    cookiePolicyInit();

    if (IsPageWithLocale("")) {
        $('#mainPageRegisterNowButton').click(function (e) {
            e.preventDefault();

            /*let queryParams = new URLSearchParams()
            queryParams.set('firstName', $('#registerFirstName').val());
            queryParams.set('lastName',  $('#registerLastName').val());
            queryParams.set('email',     $('#registerEmail').val());

            window.location.href = $('#homepageRegisterForm').attr('action') + '?' + queryParams.toString()*/

            $('#homepageRegisterForm').submit();
        });
    }
});

function materializeInit() {
    M.Dropdown.init(document.querySelectorAll('.dropdown-trigger'));
    M.Modal.init(document.querySelectorAll('.modal'));
    M.Sidenav.init(document.querySelectorAll('.sidenav'));
    M.FormSelect.init(document.querySelectorAll('select'));
}

function cookiePolicyInit() {
    let cookieModalInstance = M.Modal.getInstance(document.getElementById('cookieModal'));
    if (!Cookies.get('isAccepted')) {
        setTimeout(function () {
            $('#cookieAcceptButton').click(function () {
                let date = new Date();
                date.setTime(date.getTime() + (365*24*60*60*1000));

                Cookies.set('isAccepted', true, {
                    expires: date
                });
                cookieModalInstance.close()
            });

            cookieModalInstance.open();
        }, 1000);
    }
}
